import { tabAccessControl } from "../../../_helpers/access-control";

let BankTabs = [
  {
    text: "All",
    path: `/bank-accounts`,
    applicationFeatureCode: "BankAccounts",
  },
  {
    text: "Transactions",
    path: `/bank-transactions`,
    applicationFeatureCode: "BankTransactions",
  },
  {
    text: "Sundry Transactions",
    path: `/sundry-transactions`,
    applicationFeatureCode: "BankTransactions",
  },
];


function GetIndexByTabName(tabName) {
  return tabAccessControl(BankTabs).findIndex((x) => x.text == tabName);
}

export { BankTabs, GetIndexByTabName };